import { FunctionComponent } from 'react'
import DrawerPortal, {
  DrawerPortalProps,
} from '@components/Drawer/DrawerPortal'

export type FollowMyTeamDrawerProps = Pick<
  DrawerPortalProps,
  'children' | 'onClose'
>

const FollowMyTeamDrawer: FunctionComponent<FollowMyTeamDrawerProps> = ({
  children,
  onClose,
}) => (
  <DrawerPortal direction="right" onClose={onClose}>
    {children}
  </DrawerPortal>
)

export default FollowMyTeamDrawer
